import { render, staticRenderFns } from "./DialogDeleted.vue?vue&type=template&id=408d86a6&scoped=true"
import script from "./DialogDeleted.vue?vue&type=script&lang=js"
export * from "./DialogDeleted.vue?vue&type=script&lang=js"
import style0 from "./DialogDeleted.vue?vue&type=style&index=0&id=408d86a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d86a6",
  null
  
)

export default component.exports